import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { fmtDate, toInputDate } from '../utils';
import { useAuth } from '../context/AuthContext';
import { formatDistanceToNow } from 'date-fns';

export default function Activities() {
  const navigate = useNavigate();
  const pluralMap = { opportunity:'opportunities', contract:'contracts', account:'accounts', contact:'contacts' };
  const [activities, setActivities] = useState([]); const [total, setTotal] = useState(0); const [page, setPage] = useState(1);
  const [subject, setSubject] = useState(''); const [body, setBody] = useState(''); const [posting, setPosting] = useState(false);
  const [loading, setLoading] = useState(true);
  const { can } = useAuth();

  const load = useCallback(async () => {
    setLoading(true);
    try { const r = await api.get('/activities', { params:{ page, limit:30 } }); setActivities(r.data.data); setTotal(r.data.total); }
    finally { setLoading(false); }
  }, [page]);

  useEffect(() => { load(); }, [load]);

  const handlePost = async () => {
    if (!subject.trim()) return;
    setPosting(true);
    try { await api.post('/activities', { type:'note', subject, body }); setSubject(''); setBody(''); load(); }
    finally { setPosting(false); }
  };

  const typeIcon = t => ({ note:'💬', created:'✅', updated:'✏️', stage_change:'🔄', status_change:'📋', mod_added:'📎' }[t] || '📌');
  const typeLabel = t => ({ note:'Note', created:'Created', updated:'Updated', stage_change:'Stage Change', status_change:'Status Change', mod_added:'Mod Added' }[t] || t);

  return (
    <>
      <div className="page-header"><span className="page-title">Activity Feed</span>
        <span style={{ fontSize:13,color:'var(--gray-400)' }}>{total} total entries</span>
      </div>
      <div className="page-body" style={{ maxWidth:760 }}>
        {can('contribute') && (
          <div className="card" style={{ marginBottom:20 }}>
            <div className="card-body">
              <div className="form-group">
                <input className="form-input" placeholder="Post a team update..." value={subject} onChange={e => setSubject(e.target.value)} onKeyDown={e => e.key === 'Enter' && !e.shiftKey && handlePost()} />
              </div>
              {subject && <>
                <div className="form-group"><textarea className="form-textarea" placeholder="Details (optional)..." value={body} onChange={e => setBody(e.target.value)} rows={3} /></div>
                <div style={{ display:'flex',gap:8 }}>
                  <button className="btn btn-primary" onClick={handlePost} disabled={posting}>{posting?'Posting...':'Post Update'}</button>
                  <button className="btn btn-secondary" onClick={() => { setSubject(''); setBody(''); }}>Cancel</button>
                </div>
              </>}
            </div>
          </div>
        )}
        <div className="card">
          <div className="card-header"><span className="card-title">All Activity</span></div>
          <div className="card-body" style={{ paddingTop:8 }}>
            {loading && <div style={{ textAlign:'center',padding:40,color:'var(--gray-400)' }}>Loading...</div>}
            {!loading && activities.length === 0 && <div className="empty-state"><div className="empty-state-icon">💬</div><div className="empty-state-text">No activity yet</div></div>}
            {activities.map(a => (
              <div className="activity-item" key={a.id}>
                <div style={{ fontSize:18,width:28,textAlign:'center',flexShrink:0 }}>{typeIcon(a.type)}</div>
                <div className="activity-content">
                  <div className="activity-subject">{a.subject}</div>
                  {a.body && <div className="activity-body">{a.body}</div>}
                  <div className="activity-meta">
                    <span style={{ background:'var(--gray-100)',color:'var(--gray-600)',padding:'1px 6px',borderRadius:8,fontSize:11,marginRight:6 }}>{typeLabel(a.type)}</span>
                    {a.user_name} · {formatDistanceToNow(new Date(a.created_at), { addSuffix:true })}
                    {a.related_type && a.related_id && pluralMap[a.related_type] && (
                      <span
                        onClick={() => navigate('/' + pluralMap[a.related_type] + '/' + a.related_id)}
                        style={{ marginLeft:6,color:'var(--primary)',cursor:'pointer',fontWeight:500,textDecoration:'underline',textUnderlineOffset:2,fontSize:11,textTransform:'capitalize' }}
                      >
                        · View {a.related_type} →
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {total > 30 && (
            <div style={{ padding:'12px 20px',borderTop:'1px solid var(--gray-100)',display:'flex',gap:8,justifyContent:'center' }}>
              <button className="btn btn-secondary btn-sm" disabled={page===1} onClick={() => setPage(p=>p-1)}>← Previous</button>
              <span style={{ fontSize:12,color:'var(--gray-400)',padding:'6px 0' }}>Page {page}</span>
              <button className="btn btn-secondary btn-sm" disabled={activities.length<30} onClick={() => setPage(p=>p+1)}>Next →</button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
